import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-action-item-audit-modal',
  templateUrl: './action-item-audit-modal.component.html',
  styleUrls: ['./action-item-audit-modal.component.scss']
})
export class ActionItemAuditModalComponent {
  @Input() isActionItemAuditModalShow!: boolean;
  @Input() actionItemNumber: string = '';
  @Output() showActionItemAuditModal = new EventEmitter<boolean>();
  ngOnInit(): void {
  }
  closeActionItemAuditModal = () => {
    this.isActionItemAuditModalShow = false;
    this.showActionItemAuditModal.emit(false);
  }

}
